module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//14.jpg?85ca11bacfad675a0165c6352872e6f9";